export default {
    yourItems: "Seus itens",
    useItem: "Usar",
    useItemSuccess: "Item utilizado com sucesso",

    itemNotExists: "Você não possui este item atualmente",
    itemAlreadyActive: "Esse item ainda está em efeito. Por favor tente novamente mais tarde",
    itemNoBuddy: "Treinador não tem um buddy",
    itemTeamListFull: "O máximo de times que você pode ter é 20",

    PokemonFullHp: "O HP do seu Pokemon está cheio",
    PokemonDead: "Pokemon precisa ser ressuscitado",
    PokemonStillAlive: "Pokemon não precisa ser ressuscitado",
    PokemonNoStatusCondition: "Pokemon não foi afetado pela condição de status",
    PokemonFullPP: "Todos os movimentos estão com PP cheio",

    sellConfirmMessage: (name) => `Você tem certeza de que quer vender seu <span class="font-weight-bold">${name}</span>?`,
    useConfirmMessage: (item, pkm) => `Você tem certeza de que quer usar o item <span class="font-weight-bold">${item}</span> on <span class="font-weight-bold">${pkm}</span>?`,
    sellSuccess: "Você vendeu o seu item com sucesso",

    wonderPassNoCooldown: "O seu Wonderpass não está em cooldown!",
    pokedailyNoCooldown: "O seu Pokedaily não está em cooldown!",
};